import { Action } from '../actions/error';

export type State = Error | null | undefined;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function error(state: State = null, action: Action) {
  switch (action.type) {
    case 'SET_ERROR':
      return action.error;

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
